import ServiceCRUD from '../../../../services/ServiceGasOrder';

class DailyStockService extends ServiceCRUD {
  constructor() {
    super(`/api/verificar-estoque-do-dia`);
  }
}

export default new DailyStockService();
